import BottomModal from "components/BottomModal";
import styles from "components/modal/PushAgreementModal.module.scss";
import FullButton from "components/buttons/FullButton";
import classNames from "classnames";
import utilStyles from "styles/utils.module.scss";
import {toast} from "react-toastify";
import {Axios} from "api";
import {captureException} from "@sentry/nextjs";
import {useContext, useMemo, useState} from "react";
import PushContext, {
    PUSH_AGREEMENT_DAY_AD,
    PUSH_AGREEMENT_INFORMATION,
    PUSH_AGREEMENT_NIGHT_AD
} from "context/PushContext";
import UserContext from "context/AuthContext";
import {KEY_EMAIL_MARKETING_AGREEMENT, KEY_SMS_MARKETING_AGREEMENT} from "pages/mypage/my-info";
import CheckboxText from "components/input/CheckboxText";
import {redirectToLogin} from "common/redirect";
import ModalContext from "context/ModalContext";

export const TOAST_NIGHT_PUSH_AGREEMENT = PUSH_AGREEMENT_NIGHT_AD;
export const TOAST_DAY_PUSH_AGREEMENT = PUSH_AGREEMENT_DAY_AD;
export const TOAST_INFORMATION_PUSH_AGREEMENT = PUSH_AGREEMENT_INFORMATION;
export const TOAST_SMS_PUSH_AGREEMENT = KEY_SMS_MARKETING_AGREEMENT;
export const TOAST_EMAIL_PUSH_AGREEMENT = KEY_EMAIL_MARKETING_AGREEMENT;

const toastKeyToTitle = {
    [TOAST_NIGHT_PUSH_AGREEMENT]: '야간 광고성 푸시알림',
    [TOAST_DAY_PUSH_AGREEMENT]: '광고성 푸시알림',
    [TOAST_SMS_PUSH_AGREEMENT]: 'SMS 수신',
    [TOAST_EMAIL_PUSH_AGREEMENT]: '이메일 수신',
    [TOAST_INFORMATION_PUSH_AGREEMENT]: '정보 수신',
}

const toastKeyToDescription = {
    [TOAST_NIGHT_PUSH_AGREEMENT]: '[헤메코] 야간 광고성 알림 수신',
    [TOAST_DAY_PUSH_AGREEMENT]: '[헤메코] 광고성 알림 수신',
    [TOAST_SMS_PUSH_AGREEMENT]: '[헤메코] SMS 수신',
    [TOAST_EMAIL_PUSH_AGREEMENT]: '[헤메코] 이메일 수신',
    [TOAST_INFORMATION_PUSH_AGREEMENT]: '[헤메코] 정보 수신',
}

export const toastMessageContent = (TOAST_KEY, isCancel = false) => {
    const toastTitle = `${toastKeyToTitle[TOAST_KEY]} ${isCancel ? '알림 신청을 취소했어요' : '알림 신청이 완료됐어요'}`;
    const now = new Date().toJSON().slice(0, 10).replaceAll('-', '.');
    const toastDescription = (
        `${toastKeyToDescription[TOAST_KEY]} ${isCancel ? '거부가 처리됐어요' : '동의가 완료됐어요'}${isCancel ? '' : ` (${now})`}`
    );

    return (
        <div className={styles.toastWrapper}>
            <div className={styles.toastTitle}>
                {toastTitle}
            </div>
            <div className={styles.toastDescription}>
                {toastDescription}
            </div>
        </div>
    )
}


export const timeToDescriptionTexts = {
    isNight: [
        "오후 9시부터 오전 8시 사이에 열리는",
        "선착순 특가 및 이벤트 등 다양한 혜택을 알려드려요"
    ],
    isDay: [
        "쿠폰, 할인, 이벤트 등",
        "다양한 쇼핑 혜택을 알려드려요!",
    ],
    isInformation : [
        "주문, 리워드, 신청알림 등",
        "서비스 이용에 필요한 정보만 보내드려요",
    ]
};

export const timeToImageUrl = {
    isNight: 'https://d1cnx04b8cgzcv.cloudfront.net/media/modal/night_push_v2.svg',
    isDay: 'https://d1cnx04b8cgzcv.cloudfront.net/media/modal/day_push.svg',
    isInformation: 'https://d1cnx04b8cgzcv.cloudfront.net/media/modal/information_push.svg',
}

export const pushMoldKeys = [
    '20230907_push_allow_coupon', '20230907_new_push_allow_coupon'
]

export const nightPushMoldKeys = [

];

export const PushAgreementModal = (props) => {
    const {isOpen, close, pushType, modalInfo} = props;

    const {sendPushAgreementRequest} = useContext(PushContext);
    const [isNightPushOn, setIsNightPushOn] = useState(false);
    const userContext = useContext(UserContext);
    const {receivedCouponMoldIdsRef, couponModalInfo, setCouponModalInfo} = useContext(ModalContext);

    const isDownloadedByMoldId = (coupon) => {
        return (receivedCouponMoldIdsRef?.current || []).includes(coupon.id);
    }

    const _modalInfo = modalInfo || couponModalInfo?.modal_list?.find(e => e.identifier === 'new_push_modal')

    const [dayPushCoupon, nightPushCoupon] = useMemo(() => {
        const dayPushCoupon = _modalInfo?.coupon_molds?.find(e => e?.mold_key?.includes('day'));
        const nightPushCoupon = _modalInfo?.coupon_molds?.find(e => e?.mold_key?.includes('night'));

        return [
            (dayPushCoupon && !isDownloadedByMoldId(dayPushCoupon)) ? dayPushCoupon : null,
            (nightPushCoupon && !isDownloadedByMoldId(nightPushCoupon)) ? nightPushCoupon : null
        ]
    }, [_modalInfo, receivedCouponMoldIdsRef]);

    const couponText = () => {
        let text = '';
        if (_modalInfo) {
            let couponRate = 0;
            let extraPoint = 0;
            if (pushType === PUSH_AGREEMENT_DAY_AD) {
                couponRate = (dayPushCoupon?.amount || 0);
                extraPoint = (dayPushCoupon?.extra_points || 0);
            } else if (pushType === PUSH_AGREEMENT_NIGHT_AD) {
                couponRate += (nightPushCoupon?.amount || 0);
                extraPoint += (nightPushCoupon?.extra_points || 0);
            }

            if (couponRate > 0) {
                text += `${couponRate}% 쿠폰`;
            }
            if (couponRate > 0 && extraPoint > 0) {
                text += ' + ';
            }
            if (extraPoint) {
                text += `${extraPoint}P`;
            }
        }

        return text;
    }

    const timeToTitleTexts = {
        isNight: {
            couponReceived: [
                "야간 광고성 푸시 알림 동의하고", "가장 먼저 혜택 소식을 받아보세요"
            ],
            couponNotReceived: [
                "야간 광고성 푸시 알림 동의하고", "{couponText} 받으세요".replace('couponText', couponText())
            ]
        },
        isDay: {
            couponReceived: [
                "광고성 푸시 알림 동의하고", "가장 먼저 혜택 소식을 받아보세요"
            ],
            couponNotReceived: [
                "광고성 푸시 알림 동의하고", "{couponText} 받아보세요".replace('couponText', couponText())
            ]
        },
        isInformation: [
            "정보성 푸시 알림동의하고", "구독한 소식을 받아보세요"
        ],
    };

    const titleTexts = useMemo(() => {
        switch (pushType) {
            case PUSH_AGREEMENT_NIGHT_AD:
                return !Boolean(nightPushCoupon) ? timeToTitleTexts.isNight.couponReceived : timeToTitleTexts.isNight.couponNotReceived;
            case PUSH_AGREEMENT_DAY_AD:
                return !Boolean(dayPushCoupon) ? timeToTitleTexts.isDay.couponReceived : timeToTitleTexts.isDay.couponNotReceived;
            case PUSH_AGREEMENT_INFORMATION:
                return timeToTitleTexts.isInformation;
        }
        return null;
    }, [pushType, dayPushCoupon, nightPushCoupon])


    const descriptionTexts = useMemo(() => {
        switch (pushType) {
            case PUSH_AGREEMENT_NIGHT_AD:
                return timeToDescriptionTexts.isNight;
            case PUSH_AGREEMENT_DAY_AD:
                return timeToDescriptionTexts.isDay;
            case PUSH_AGREEMENT_INFORMATION:
                return timeToDescriptionTexts.isInformation;
        }
        return null;
    }, [pushType])

    const imageLink = useMemo(() => {
        switch (pushType) {
            case PUSH_AGREEMENT_NIGHT_AD:
                return timeToImageUrl.isNight;
            case PUSH_AGREEMENT_DAY_AD:
                return timeToImageUrl.isDay;
            case PUSH_AGREEMENT_INFORMATION:
                return timeToImageUrl.isInformation;
        }
        return null;
    }, [pushType]);

    const downloadPushAgreementCoupon = async (data) => {
        try {
            const downloadMoldKeys = [];

            if (Boolean(dayPushCoupon) && data.is_day_push_agreed) {
                downloadMoldKeys.push(dayPushCoupon?.mold_key);
            }
            if (Boolean(nightPushCoupon) && data.is_night_push_agreed) {
                downloadMoldKeys.push(nightPushCoupon?.mold_key);
            }
            if (downloadMoldKeys.length === 0) {
                return;
            }

            const res = await  Axios.post('v1/coupons/download-bulk', {
                mold_keys: downloadMoldKeys,
            });

            if (res.status < 400) {
                userContext.setCouponInfo(res?.data?.coupon_state || {});
                const downloadedMoldIds = res?.data?.coupon_state?.coupons?.filter(
                    e => e.coupon_mold_key && downloadMoldKeys.includes(e.coupon_mold_key)
                ).map(e => e.coupon_mold_id) || [];

                receivedCouponMoldIdsRef.current = receivedCouponMoldIdsRef.current.concat(
                    downloadedMoldIds
                );
                setCouponModalInfo(prev => ({
                    ...prev,
                    modal_list: prev?.modal_list?.filter(e => e.identifier !== 'new_push_modal')
                }));

                let toastText = null;
                if (pushType === PUSH_AGREEMENT_DAY_AD) {
                    toastText = '쿠폰이 발급되었어요!';
                } else if (pushType === PUSH_AGREEMENT_NIGHT_AD) {
                    toastText = '포인트를 받았어요!';
                }

                if (toastText) {
                    toast.info(toastText);
                }
                
            } else if (res.status === 409) {
                toast.info('이미 푸시 동의 쿠폰을 받았어요.');
            } else {
                toast.info('쿠폰 다운로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
            }
        } catch (e) {
            toast.info('쿠폰 다운로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        }
    };

    const onConfirmClick = async () => {
        if (!Boolean(userContext?.user?.nickname)) {
            redirectToLogin();
        }

        const data = {
            is_day_push_agreed: pushType === PUSH_AGREEMENT_DAY_AD ? true : null,
            is_night_push_agreed: (
                pushType === PUSH_AGREEMENT_DAY_AD && isNightPushOn
            ) || (pushType === PUSH_AGREEMENT_NIGHT_AD ? true : null),
            is_informational_push_agreed: pushType === PUSH_AGREEMENT_INFORMATION ? true : null,
        };

        const successCallback = () => {
            close();
            toast(toastMessageContent(pushType), {
                closeButton: false,
                onClose: () => {
                    downloadPushAgreementCoupon(data);
                }
            });
        }

        sendPushAgreementRequest({
            isDayAgree: pushType === PUSH_AGREEMENT_DAY_AD ? true : null,
            isNightAgree: (pushType === PUSH_AGREEMENT_DAY_AD && isNightPushOn) || (pushType === PUSH_AGREEMENT_NIGHT_AD ? true : null),
        }, successCallback);
    };

    const onCancelClick = () => {
        close();
    };

    const applyHighlightText = (text) => {
        const regex = /{(.*?)}/g;
        const parts = [];
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                parts.push(text.slice(lastIndex, match.index));
            }
            parts.push(<span className={styles.titleHighlightWrapper} key={match.index}>{match[1]}</span>);
            lastIndex = regex.lastIndex;
        }

        if (lastIndex < text.length) {
            parts.push(text.slice(lastIndex));
        }

        return <span className={styles.titleWrapper}>{parts}</span>;
    }

    return (
        <BottomModal isOpen={isOpen} close={() => {
            close();
        }}>
            <div className={styles.root}>
                <div className={styles.titleWrapper}>
                    {
                        titleTexts?.map((text, index) => (
                            <div key={'push-modal-title-' + index} className={styles.title}>
                                {applyHighlightText(text)}
                            </div>
                        ))
                    }
                </div>
                <div className={styles.descriptionWrapper}>
                    {
                        descriptionTexts?.map((text, index) => (
                            <div key={'push-modal-description-' + index} className={styles.description}>
                                {text}
                            </div>
                        ))
                    }
                </div>
                <object
                    data={imageLink}
                    type="image/svg+xml"
                    className={styles.svgWrapper}
                />
                {
                    pushType === PUSH_AGREEMENT_DAY_AD &&
                    <div className={styles.checkBoxContainer}>
                        <div className={styles.checkBoxWrapper}>
                            <CheckboxText checked={isNightPushOn} onClick={() => {
                                setIsNightPushOn(!isNightPushOn);
                            }}/>
                        </div>
                        <div className={styles.checkboxTextWrapper}>
                            <span className={styles.checkboxText}>야간 광고성 알림(21:00~08:00)도 같이 받을래요</span>
                            {
                                (nightPushCoupon && nightPushCoupon?.extra_points) &&
                                <span className={styles.checkboxTextHighlight}>{`+${nightPushCoupon.extra_points}P 추가`}</span>
                            }
                        </div>
                    </div>
                }
                <div
                    className={classNames(utilStyles.flexRow, utilStyles.alignItemsCenter, styles.bottomButtonContainer)}
                >
                    <div className={styles.cancelButtonWrapper}>
                        <FullButton white title={'다음에'} height={48} fontSize={16}
                                    onClick={onCancelClick}/>
                    </div>
                    <div className={styles.confirmButtonWrapper}>
                        <FullButton title={'알림 받기'} height={48} fontSize={16}
                                    onClick={onConfirmClick}/>
                    </div>
                </div>
            </div>
        </BottomModal>
    )
}

export default PushAgreementModal;
